export default {
  trackingQuery: {
    title: 'Tracking Query',
    subtitle: 'Enter the Bill of Lading Number and Shipping Company to quickly query real-time cargo tracking',
    billNo: 'Bill of Lading Number',
    billNoPlaceholder: 'Please enter the Bill of Lading Number',
    billNoRequired: 'Please enter the Bill of Lading Number',
    carrier: 'Shipping Company',
    carrierPlaceholder: 'Please enter or select the Shipping Company',
    selectCarrier: 'Please select the Shipping Company',
    carrierRequired: 'Please enter the Shipping Company',
    mapTitle: 'Tracking Map',
    mapPlaceholder: 'Please enter the Bill of Lading Number and Shipping Company to query',
    mapLoading: 'Loading tracking map...',
    querySuccess: 'Query successful',
    queryFailed: 'Query failed, please try again later',
    modal: {
      loginTitle: 'Login Required',
      loginMessage: 'Please log in to use the tracking query feature',
      goToLogin: 'Go to Login',
      certifyTitle: 'Certification Required',
      certifyMessage: 'Please complete enterprise certification to use the tracking query feature',
      goCertify: 'Go to Certification',
      understood: 'Got it',
      goToAppCenter: 'Go to App Center',
      pendingTitle: 'Application Under Review',
      pendingMessage: 'Your tracking query application is under review, you can use this feature after approval',
      rejectedTitle: 'Application Rejected',
      rejectedMessage: 'Your tracking query application was rejected, please go to the App Center for details and reapply',
      disabledTitle: 'Application Disabled',
      disabledMessage: 'The tracking query application has been disabled, please contact the administrator',
      notActivatedTitle: 'Activation Required',
      notActivatedMessage: 'Please activate the tracking query application in the App Center before use',
    }
  }
}